
import React from "react";
import { 
  Carousel, 
  CarouselContent, 
  CarouselItem,
  CarouselPrevious,
  CarouselNext 
} from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { QuoteIcon } from "lucide-react";

const TocFotosTestimonials = () => {
  const testimonials = [
    {
      quote: "Muito fácil, atendem em bons horários e o resultado das fotos é incrível. Consegui fechar mais negócios graças à qualidade das imagens.",
      author: "Jessica",
      role: "Corretora"
    },
    {
      quote: "Eu ameeei, nem parece o mesmo imóvel! As fotos profissionais fizeram toda a diferença na hora de divulgar meu apartamento.",
      author: "Juliana",
      role: "Proprietária"
    },
    {
      quote: "A procura aumentou muito e consegui vender meu imóvel em menos de um mês. As fotos da Toc Toc fizeram toda a diferença.",
      author: "Ricardo",
      role: "Proprietário"
    },
    {
      quote: "Vale cada centavo. A fotografia profissional é um investimento que se paga rapidamente com a valorização do imóvel.",
      author: "Sofia",
      role: "Proprietária"
    },
    {
      quote: "Posso focar nas vendas e delegar a fotografia para quem entende. Isso traz muito mais eficiência para o meu trabalho.",
      author: "Ana",
      role: "Corretora"
    }
  ];

  return (
    <div id="depoimentos" className="container max-w-7xl mx-auto px-4">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-semibold text-[#261E13] mb-4">
          O QUE NOSSOS CLIENTES DIZEM?
        </h2>
        <p className="text-lg md:text-xl text-[#261E13]/70 max-w-2xl mx-auto">
          Histórias de sucesso de quem já utilizou nossos serviços
        </p>
      </div>
      
      <Carousel 
        className="w-full"
        opts={{
          align: "start",
          loop: true,
        }}
      >
        <CarouselContent>
          {testimonials.map((testimonial, index) => (
            <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3 pl-4">
              <Card className="border border-[#FF5605]/20 h-full bg-white">
                <CardContent className="p-6">
                  <div className="mb-4 text-[#FF5605]">
                    <QuoteIcon size={32} />
                  </div>
                  <p className="italic mb-6 text-[#261E13]/80">
                    "{testimonial.quote}"
                  </p>
                  <div>
                    <p className="font-semibold text-[#261E13]">{testimonial.author}</p>
                    <p className="text-sm text-[#261E13]/60">{testimonial.role}</p>
                  </div>
                </CardContent>
              </Card>
            </CarouselItem>
          ))}
        </CarouselContent>
        
        <div className="mt-6 flex justify-center gap-4">
          <CarouselPrevious className="relative position-static" />
          <CarouselNext className="relative position-static" />
        </div>
      </Carousel>

      {/* Dots indicator */}
      <div className="flex justify-center gap-2 mt-8">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`h-2 rounded-full transition-all w-2 bg-gray-300`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default TocFotosTestimonials;
